export const LOGO_URL = "https://customer-assets.emergentagent.com/job_58284b88-53d8-4c2d-a757-f70994c6780a/artifacts/yxcl41jr_17fb61916fadfcb65ccf78419aa879e3f44d8d6b4289b01fdfd0f1c53d7537c0.png";
